module.exports = __webpack_public_path__ + "img/h14.19defcd2.jpg";